import { render, staticRenderFns } from "./InstallmentPlanChannelCreate.vue?vue&type=template&id=dfc6b65e&"
import script from "./InstallmentPlanChannelCreate.vue?vue&type=script&lang=js&"
export * from "./InstallmentPlanChannelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports